import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { RoundedSection } from '../../../../common/RoundedSection/RoundedSection';
import { TERMS_LINK } from '../CarPrizeDraw.helpers';

import Texts from './EligibilityAndEntryCriteria.texts.json';

import styles from './EligibilityAndEntryCriteria.module.scss';

const LocalT = new MDText(Texts);

export const EligibilityAndEntryCriteria = () => {
  const link = <Hyperlink href={TERMS_LINK} label={Texts.clickHere} size="large" underline={false} />;

  return (
    <RoundedSection withBottomLedge withTopLedge theme="off-white">
      <div className={styles.component}>
        <h2 className={styles.title}>{Texts.title}</h2>
        <div className={styles.body}>
          <p>{Texts.body.p1}</p>
          <p>{Texts.body.p2}</p>
        </div>
        <p data-thc-style-override className={styles.termsLink}>{LocalT.translate('termsConditions', { link })}</p>
      </div>
    </RoundedSection>
  );
};
